import "./calendarItem.less";
import IntlMessages from "@util/IntlMessages";
import { Icon_CalendarWithClock } from "../../../BP2Components/Icons/icons";
import moment from "moment";

const getSubtractedDate = (date) => {
   const YMD = date.split(" ")[0];
   const HMS = date.split(" ")[1];

   const year = parseInt(YMD.split("-")[0]);
   const month = parseInt(YMD.split("-")[1]) - 1;
   const day = parseInt(YMD.split("-")[2]);

   const hours = parseInt(HMS.split(":")[0]);
   const minutes = parseInt(HMS.split(":")[1]);
   const seconds = parseInt(HMS.split(":")[2]);

   return parseInt(
      (new Date(year, month, day, hours, minutes, seconds).getTime() - new Date()) /
         (3600 * 24 * 1000),
   );
};

const formatedValue = (value) => {
   if (value && value.length === 19 && value[4] === "-" && value[7] === "-") {
      let diff = getSubtractedDate(value);
      if (diff >= 0) {
         diff = Math.abs(diff);
         if (diff > 1)
            return (
               <>
                  {diff} <IntlMessages id="advertismentList.calendarDaysLeft" />
               </>
            );
         else
            return (
               <>
                  {diff} <IntlMessages id="advertismentList.calendarDaysLeftOne" />
               </>
            );
      } else {
         diff = Math.abs(diff);
         if (diff > 1)
            return (
               <>
                  {diff} <IntlMessages id="advertismentList.calendarDaysAgo" />
               </>
            );
         else
            return (
               <>
                  {diff} <IntlMessages id="advertismentList.calendarDaysAgoOne" />
               </>
            );
      }
   } else {
      return value;
   }
};

const CalendarItem = ({ value, title, showTitle, format }) => {
   if (title === "-" || title === null || title === "") return null;
   return (
      <div className="gx-product-body-calendar">
         <Icon_CalendarWithClock fill="#525252" stroke="none" />
         <p className="p1">
            {showTitle === true && <>{title}: </>}
            {format !== "date" ? moment(value).format("DD.MM.YYYY HH:mm") : formatedValue(value)}
         </p>
      </div>
   );
};

export default CalendarItem;
